import LeaseSummaryBox from './components/LeaseSummaryBox';
import classes from './index.module.scss';
import React, { useEffect } from 'react';
import SignLeaseActionButton from '../SharedComponents/SignLeaseActionButton';
import useSignLease from '../../context';
import SignLeaseTerms from './components/SignLeaseTerms';
import useAuth from '../../../../../context/Auth';
import DotsLoader from '../../../../../components/animations/Loaders/DotsLoader';
import { useLandaRouter } from '../../../../../hooks/logics/useLandaRouter';
import { RESIDENTS_FEED_ROUTE } from '../../../../../consts/routes/urls';
import CustomErrorComponent from '../../../../_error.page';

const LeaseSummary = () => {
  const { data, error, loading } = useSignLease();
  const { isLoggedIn } = useAuth();
  const { navigate } = useLandaRouter();
  useEffect(() => {
    if (
      error ||
      data?.units.length === 0 ||
      data?.units[0].onMarketLease === null
    )
      navigate(RESIDENTS_FEED_ROUTE);
  }, [error, data]);

  if (!data || loading)
    return (
      <div className={classes.container}>
        <DotsLoader isLoading={true} />
      </div>
    );
  if (
    error ||
    data?.units.length === 0 ||
    data?.units[0].onMarketLease === null
  ) {
    return <CustomErrorComponent />;
  }

  return (
    <div className={classes.container}>
      <LeaseSummaryBox className={classes.orderSummary} />
      {isLoggedIn && (
        <>
          <SignLeaseActionButton className={classes.button} />
          <SignLeaseTerms />
        </>
      )}
    </div>
  );
};

export default LeaseSummary;
